module.exports = __webpack_public_path__ + "img/logo.a00dec3e.png";